import { api } from "@/services/api"
import { useMutation } from "@tanstack/react-query"
import type { Params } from "@/services/api/odin/activities/challenge/study-session/create"

export default function useCreateChallengeStudySession() {
  const mutation = useMutation({
    mutationFn: (params: Params) => {
      return api.odin.activities.challenges.studySession.create(params)
    },
  })

  return mutation
}
